import env from "../../../env"
import setIfNotSet from "../../../setIfNotSet"
import {PRODUCTION} from "../../../constants/environment"
import type {APIRequestConfig} from "../../API"

export const VIVUP_OVERRIDE_HEADER = "x-pb-vivup"
export const VIVUP_PARTNER_ID_OVERRIDE_HEADER = "x-pb-vivup-partner-id"

export function appendVivupOverrideHeaders(config: APIRequestConfig): void {
  const vivupUrl = env.VIVUP_URL.trim()

  // graph resolves (and allowlists) the Vivup alias in every environment
  if (vivupUrl !== "") {
    setIfNotSet(config, `headers.${VIVUP_OVERRIDE_HEADER}`, vivupUrl)
  }

  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return
  }

  const vivupPartnerId = env.VIVUP_PARTNER_ID.trim()

  if (vivupPartnerId !== "") {
    setIfNotSet(config, `headers.${VIVUP_PARTNER_ID_OVERRIDE_HEADER}`, vivupPartnerId)
  }
}
